import { render } from "./MobileRegister.vue?vue&type=template&id=18e4369b&scoped=true&ts=true"
import script from "./MobileRegister.vue?vue&type=script&lang=ts"
export * from "./MobileRegister.vue?vue&type=script&lang=ts"

import "./MobileRegister.vue?vue&type=style&index=0&id=18e4369b&scoped=true&lang=less"

import exportComponent from "D:\\sunrun_luo\\JK-neibu\\JKai-zhuzhan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e4369b"]])

export default __exports__